<div
  class="column-filter"
  [class.column-filter--advanced-search]="filterType() === 'advancedSearch'"
>
  <h4 class="filter-title">
    {{
      'components.mat-table.filter.title'
        | transloco: { columnLabel: translatedColumnLabel() }
    }}
  </h4>

  <form [formGroup]="filterForm" (ngSubmit)="applyFilter()">
    <!-- Text Filter -->
    @if (filterType() === 'text') {
      <mat-label>
        {{ 'components.mat-table.filter.operator' | transloco }}
      </mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="operator">
          @for (op of availableOperators(); track op.value) {
            <mat-option [value]="op.value">
              {{ op.label | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (!isNullOperator()) {
        <app-input
          formControlName="value"
          [label]="'components.mat-table.filter.value' | transloco"
          [placeholder]="
            'components.mat-table.filter.placeholders.value' | transloco
          "
          [required]="false"
          [editMode]="true"
        ></app-input>
      }
    }

    <!-- Number Filter -->
    @if (filterType() === 'number') {
      <mat-label>
        {{ 'components.mat-table.filter.operator' | transloco }}
      </mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="operator">
          @for (op of availableOperators(); track op.value) {
            <mat-option [value]="op.value">
              {{ op.label | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (!isNullOperator()) {
        <app-input
          formControlName="value"
          [label]="
            isBetweenOperator()
              ? ('components.mat-table.filter.from' | transloco)
              : ('components.mat-table.filter.value' | transloco)
          "
          [required]="false"
          [editMode]="true"
          inputType="number"
          [placeholder]="
            'components.mat-table.filter.placeholders.value' | transloco
          "
        ></app-input>

        @if (isBetweenOperator()) {
          <app-input
            formControlName="valueTo"
            [label]="'components.mat-table.filter.to' | transloco"
            [required]="false"
            [editMode]="true"
            inputType="number"
            [placeholder]="
              'components.mat-table.filter.placeholders.value' | transloco
            "
          ></app-input>
        }
      }
    }

    <!-- Date Filter -->
    @if (filterType() === 'date') {
      <mat-label>
        {{ 'components.mat-table.filter.operator' | transloco }}
      </mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="operator">
          @for (op of availableOperators(); track op.value) {
            <mat-option [value]="op.value">
              {{ op.label | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (!isNullOperator()) {
        <mat-label>
          {{
            isBetweenOperator()
              ? ('components.mat-table.filter.from' | transloco)
              : ('components.mat-table.filter.date' | transloco)
          }}
        </mat-label>
        <app-date-input
          formControlName="value"
          [editMode]="true"
          [required]="false"
          [placeholder]="
            'components.mat-table.filter.placeholders.date' | transloco
          "
        />

        @if (isBetweenOperator()) {
          <mat-label>
            {{ 'components.mat-table.filter.to' | transloco }}
          </mat-label>
          <app-date-input
            formControlName="valueTo"
            [editMode]="true"
            [required]="false"
            [placeholder]="
              'components.mat-table.filter.placeholders.date' | transloco
            "
          />
        }
      }
    }

    <!-- Boolean Filter -->
    @if (filterType() === 'boolean') {
      <mat-label>
        {{ 'components.mat-table.filter.operator' | transloco }}
      </mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="operator">
          @for (op of availableOperators(); track op.value) {
            <mat-option [value]="op.value">
              {{ op.label | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (!isNullOperator()) {
        <app-radio
          [options]="[
            {
              value: true,
              label: 'components.mat-table.filter.true' | transloco,
            },
            {
              value: false,
              label: 'components.mat-table.filter.false' | transloco,
            },
          ]"
          [data]="filterForm.controls.value.value"
          (dataChange)="onBooleanValueChange($event)"
        />
      }
    }

    <!-- Select Filter -->
    @if (filterType() === 'select') {
      <mat-label>
        {{ 'components.mat-table.filter.value' | transloco }}
      </mat-label>
      <app-drop-down
        formControlName="value"
        [options]="translatedFilterOptions()"
        [placeholderOption]="
          'components.mat-table.filter.placeholders.select' | transloco
        "
        [clearable]="false"
        [label]="null"
      />
    }

    <!-- Multi Select Filter -->
    @if (filterType() === 'multiselect') {
      <mat-label>
        {{ 'components.mat-table.filter.value' | transloco }}
      </mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select
          #multiSelect
          formControlName="value"
          [multiple]="true"
          [placeholder]="
            'components.mat-table.filter.placeholders.select' | transloco
          "
          [panelClass]="'column-filter-multiselect-panel'"
          (openedChange)="onMultiSelectOpened($event)"
          (selectionChange)="onMultiSelectSelectionChange()"
        >
          @for (option of translatedFilterOptions(); track option.value) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (filterType() === 'infiniteMultiselect' && filterDynamicList()) {
      @if (availableOperators().length > 1) {
        <mat-label>
          {{ 'components.mat-table.filter.operator' | transloco }}
        </mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select formControlName="operator">
            @for (op of availableOperators(); track op.value) {
              <mat-option [value]="op.value">
                {{ op.label | transloco }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (!isNullOperator()) {
        <app-infinite-dropdown
          #infiniteMultiselectDropdown
          formControlName="value"
          [multiple]="true"
          [pageSize]="20"
          [fetchPage]="listItemsFetchPage"
          [label]="'components.mat-table.filter.value' | transloco"
          [labelAccessor]="dynamicListLabelAccessor"
          [valueAccessor]="dynamicListValueAccessor"
          [optionMatTooltip]="false"
          [useMultiselectValueOverlay]="true"
          [emitOnEveryChange]="false"
          [prefetchedRows]="infiniteMultiselectPrefetchedRows()"
        />
      }
    } @else if (
      filterType() === 'infiniteMultiselect' && !filterDynamicList()
    ) {
      <p class="filter-config-missing">
        {{ 'components.mat-table.filter.dynamicListConfigMissing' | transloco }}
      </p>
    }

    @if (filterType() === 'advancedSearch' && advancedSearchConfig()) {
      <mat-label>
        {{ 'components.mat-table.filter.operator' | transloco }}
      </mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="operator">
          @for (op of availableOperators(); track op.value) {
            <mat-option [value]="op.value">
              {{ op.label | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <app-advanced-search-select
        formControlName="value"
        [config]="advancedSearchConfig()!"
        [label]="'components.mat-table.filter.value' | transloco"
        [can_create]="false"
        [can_edit]="advancedSearchCanEdit()"
      />
    } @else if (filterType() === 'advancedSearch') {
      <p class="filter-config-missing">
        {{
          'components.mat-table.filter.advancedSearchConfigMissing' | transloco
        }}
      </p>
    }

    <!-- Action Buttons -->
    <div class="filter-actions">
      <app-button
        variant="filled"
        type="primary"
        [label]="'core.buttons.apply' | transloco"
        (click)="applyFilter()"
      ></app-button>
      <app-button
        variant="text"
        [label]="'core.buttons.clear' | transloco"
        (click)="clearFilter(); $event.stopPropagation()"
      ></app-button>
    </div>
  </form>
</div>
